<template>
    <div>
    </div>
</template>
<script>
import axios from 'axios';
  export default {
    name: 'GetSchoolArmsRecordAxios',
    props:[
        'authToken',
        'school',
        'refreshSignal'
    ],
    mounted() {
       this.getRecords()
    },
    data: () => ({
    }),
    watch:{
        refreshSignal(signal){
            console.log(signal)
            this.getRecords()
        }
    },
    methods: {
        getRecords () {
            axios.get(process.env.VUE_APP_BASEURL+'/schoolarms',
            {
                headers: 
                {
                    'Authorization': 'Bearer '+this.authToken
                }
            })
            .then((response) => {
                this.$emit("get_schoolarms", response.data.data); // Emit the event with data          
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
            });
        },
    },
  }
</script>